@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.linkshare

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint

object AttachRideToLinkShareEndpoint :
    EndPoint<AttachRideToLinkShareEndpoint.Request, AttachRideToLinkShareEndpoint.Response>() {
    class Request(
        val linkShareLogId: KmmLong,
        val rideId: KmmLong,
    )

    class Response(
        val success: Boolean,
    )
}
